<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'call-details',
            }"
        ></dx-grid></div
></template>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Calls",
        columns: [
            {
                field: "direction",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "INC":
                            return "mdi-phone-incoming";
                        case "OUT":
                            return "mdi-phone-outgoing";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "INC":
                            return "info";
                        case "OUT":
                            return "#2196f3";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Account ID",
                field: "accountID",
                template: "link-action-cell-template",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(moment()),
                selectedFilterOperation: "=",
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "recording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "userName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "End Time",
                field: "callEndTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Internal Number:",
                field: "internalNumber",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        action: "",
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onAccountIDClick;

        this.user = this.$store.state.authentication.user;
    },
    mounted() {},
    methods: {
        async beforeSetupGrid() {
            this.columns.find(
                (c) => c.field == "accountID",
            ).linkAction = this.onAccountIDClick;

            this.url = "calls?type=CUSTOMER_CALL&callName=&broadcastID=";
        },
        onAccountIDClick(row) {
            this.onRowClicked(row);
        },
        async onRowClicked(row) {
            if (row.accountID) {
                this.$router.push({
                    name: "Account View",
                    params: {
                        id: row.accountID,
                    },
                    // query: {
                    //     goToCallbackSection: true,
                    // },
                });

                return;
            }
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value.substring(1));
        },
    },
};
</script>
